import React from "react";

import svg from "../../assets/images/icons/Form Controls/Password Box.svg";

export const PasswordBoxIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Password"}
    />
);
